/**
 * How much room an action button takes, which is how loudly it asks to be pressed.
 *
 * A button stretched across its column reads as the thing to do next. A button no wider than its
 * own label reads as available. A destructive action wants the second: Leave Team on a work
 * agreement has hugged its label since it was written, and #5240 is the report that End Agreement
 * and Cancel Proposal were drawn louder than it.
 *
 * Both of those sit in a grid whose tracks are sized for stretched buttons, and both are styled
 * from a base that declares `width: 100%`. So hugging is an override rather than the absence of a
 * rule, which is why it is written here once instead of being spelled out at each call site.
 *
 * Where a row of actions stacks into a column, a full-width button is what reads correctly, so a
 * caller lifts this where its own row seats one button — see `actionRowSeatsOneButton`. The lift is
 * the caller's to write because only the caller knows the row's gap, so it is deliberately not
 * part of this rule.
 */
export const hugsItsLabel = {
  minWidth: "unset",
  width: "auto",
} as const;
